import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBase";

export const peopleOfInterestApi = createApi({
  reducerPath: "peopleApi",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    downloadPeopleCSV: builder.mutation<void, void>({
      query: () => ({
        url: "people-of-interest/export-csv",
        method: "GET",
        credentials: "include",
        responseHandler: (response) => response.blob(),
      }),
      transformResponse(blob: Blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "people.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    
        return; 
      },
      extraOptions: {
        skipTracking: true // opcional, evita guardar esta mutation en el state por completo
      }
    }),
    
  }),
});

export const { useDownloadPeopleCSVMutation } = peopleOfInterestApi;
